export class mathHelper {
  static PercentageText(part, whole) {
    return `${parseInt(whole) === 0 || part === 0 ? 0 : Math.round((part / parseFloat(whole)) * 10000) / 100}%`;
  }

  static PercentageTextTwoDecimal(part, whole) {
    return (
      parseFloat(
        parseInt(whole) === 0 || part === 0 ? 0 : Math.round((part / parseFloat(whole)) * 10000) / 100,
        2
      ).toFixed(2) + '%'
    );
  }

  static SimplePercentageTextTwoDecimal(number) {
    return `${parseFloat(number, 2).toFixed(2)}%`;
  }

  static LimitMax(value, max) {
    return value > max ? max : value;
  }

  static LimitMin(value, min) {
    return value < min ? min : value;
  }

  static LimitMaxMin(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
  }

  static Sum(array) {
    return array.reduce((a, b) => a + b, 0);
  }

  static ContainsNegative(array) {
    return array.some((element) => parseInt(element) < 0);
  }

  static RemoveLeadingZeros(value) {
    if (value === 0) return 0;
    return value.toString().replace(/^0+/, '');
  }

  static ForceConvertToNumber(value, defaultValue = -1) {
    value = parseInt(value);
    if (isNaN(value) || value === null || value === undefined) return defaultValue;
    return value;
  }

  static RandomInt(exclusiveLimit) {
    return Math.floor(Math.random() * exclusiveLimit);
  }

  static RoundToTwoDecimal(num) {
    return Math.round(num * 100) / 100;
  }

  static ConvertToTwoDecimalNumber(input) {
    try {
      return parseFloat(input).toFixed(2);
    } catch (error) {
      return input;
    }
  }
}

export default mathHelper;
